import { getResponseHeader } from '~/lib/utils/fetch';

export const useGamingStreakHeader = (response) => {
  const gaming = useGamingStore();
  const streakHeader = getResponseHeader(
    response,
    AdamHeader.NomadGamingStreak
  );

  if (streakHeader) {
    gaming.setStreak(parseInt(streakHeader, 0));
  }
};
